import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, UntypedFormGroup, UntypedFormControl, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@src/app/shared/services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-edit-price-tier-modal',
    templateUrl: './edit-price-tier-modal.component.html',
})
export class EditPriceTierModalComponent implements OnInit {
    priceTierForm: UntypedFormGroup;
    public currentDate: Date = new Date();

    constructor(
        private apiService: ApiService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<EditPriceTierModalComponent>,
        private toast: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: { priceTier: any, type: string, effectiveFrom?: Date }
    ) { }

    ngOnInit(): void {
        if (this.data?.effectiveFrom) {
            this.currentDate = this.data.effectiveFrom;
        }
        this.initForm();
    }

    private initForm(): void {
        this.priceTierForm = new UntypedFormGroup({
            id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.id : ''
            ),
            product_id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.product_id : ''
            ),
            manufacturer_id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.manufacturer_id : '',
                Validators.required
            ),
            effective_from: new FormControl<Date>(null, Validators.required),
            tier: new UntypedFormControl(
                {value: this.data?.priceTier ? this.data?.priceTier?.tier : 0, disabled: this.data?.type === 'edit' ? true : false},
                Validators.required
            ),
            operative_cost: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.operative_cost : '',
                Validators.required
            ),
            subcontractor_cost: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.subcontractor_cost : '',
                Validators.required
            ),
            material_cost: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.material_cost : '',
                Validators.required
            ),
            sell_price: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.sell_price : '',
                Validators.required
            )
        });
    }

    save(): void {
        if (this.priceTierForm.valid) {
            this.priceTierForm.patchValue({
                effective_from: moment(this.priceTierForm.get('effective_from').value).format('YYYY-MM-DD HH:mm:ss'),
            });

            if (this.data?.type === 'edit') {
                // Update
                this.apiService.update('products/prices', this.priceTierForm.get('id').value, this.priceTierForm.getRawValue()).subscribe({
                    next: (response) => {
                        this.dialogRef.close(response);
                        this.toast.success('Price successfully updated.');
                    },
                    error: (error) => {
                        console.error('Error updating price tier:', error);
                    }
                });
            } else {
                // Create
                this.apiService.create('products/prices', this.priceTierForm.getRawValue()).subscribe({
                    next: (response) => {
                        this.dialogRef.close(response);
                        this.toast.success('New price successfully saved.');
                    },
                    error: (error) => {
                        console.error('Error creating price tier:', error);
                    }
                });
            }
        } else {
            this.toast.error('Please fill in all required fields.');
        }
    }
}
